import Immutable from 'immutable';
import get from 'lodash/get';

import * as actions from './actions';
import * as helpers from './helpers';

const initialState = Immutable.Map({
  tree: {
    children: [],
  },
  parent: null,
  selectedPath: [],
  selectedId: null,
  lastNodeRequired: false,
});

const treePicker = (state = initialState, action) => {
  switch (action.type) {
    case actions.INIT_TREEPICKER: {
      const tree = get(action, 'tree.tree', {});
      const lastNodeRequired = get(action, 'tree.lastNodeRequired', false);

      return state.set('tree', tree).set('lastNodeRequired', lastNodeRequired);
    }
    case actions.SELECT_NODE: {
      const nodeId = action.nodeId;

      const tree = state.get('tree');
      const selectedPath = helpers.getPath(tree, nodeId);

      return state.set('selectedId', nodeId).set('selectedPath', selectedPath);
    }
    case actions.UPDATE_PARENT: {
      const parentId = action.parentId;

      if (!parentId) return state.set('parent', null).set('selectedPath', []);

      const tree = state.get('tree');
      const selectedPath = helpers.getPath(tree, parentId);
      const parent = helpers.findNode(tree, parentId);

      return state.set('parent', parent).set('selectedPath', selectedPath);
    }
    case actions.CLEAR_TREEPICKER: {
      return state.merge({
        parent: null,
        selectedPath: [],
        selectedId: null,
      });
    }
    default: {
      return state;
    }
  }
};

export default treePicker;
